/**
 * Batch execution status enum
 * Defines all possible statuses for batch execution
 */
export enum BatchStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  ALL = "ALL",
}

/**
 * Batch status display text mapping
 */
export const BatchStatusDisplayText = {
  [BatchStatus.SUCCESS]: "成功",
  [BatchStatus.FAILED]: "エラー",
  [BatchStatus.PENDING]: "処理中",
  [BatchStatus.PROCESSING]: "処理中",
  [BatchStatus.ALL]: "すべて",
} as const;

/**
 * Batch status CSS class mapping
 */
export const BatchStatusClass = {
  [BatchStatus.SUCCESS]: "status-success",
  [BatchStatus.FAILED]: "status-error",
  [BatchStatus.PENDING]: "status-pending",
  [BatchStatus.PROCESSING]: "status-processing",
  [BatchStatus.ALL]: "status-all",
} as const;

/**
 * Get display text for batch status
 */
export function getBatchStatusDisplayText(status: BatchStatus): string {
  return BatchStatusDisplayText[status] || status;
}

/**
 * Get CSS class for batch status
 */
export function getBatchStatusClass(status: BatchStatus): string {
  return BatchStatusClass[status] || "status-unknown";
}

/**
 * Check if status is an error status
 */
export function isErrorStatus(status: BatchStatus): boolean {
  return status === BatchStatus.FAILED;
}

/**
 * Check if status is a success status
 */
export function isSuccessStatus(status: BatchStatus): boolean {
  return status === BatchStatus.SUCCESS;
}

/**
 * Check if status is a pending status
 */
export function isPendingStatus(status: BatchStatus): boolean {
  return status === BatchStatus.PENDING;
}
